/* eslint-disable no-unused-vars */
import Vue from 'vue'
import store from './../store'
import Router from 'vue-router'
import Account from '@/views/layout/Account'
import Main from '@/views/layout/Main'
import Campaign from '@/views/campaign/index'
import Blank from '@/views/layout/Blank'
import Webview from '@/views/layout/Webview'
import Championship from '@/views/layout/Championship'
import Proxy from '@/views/proxy/index'
import ResetPassword from '@/views/layout/ResetPassword'
import CheckoutCounter from '@/views/layout/CheckoutCounter'
import CheckoutCounterBCPay from '@/views/layout/CheckoutCounterBCPay'
import DailyAttend from '@/views/layout/DailyAttend'
import { showNotice } from '@/utils/tool'
import i18n from '@/i18n'

Vue.use(Router)

export const routerMap = [
  {
    // 錦標賽
    component: Championship,
    path: '/championship'
  },
  {
    // 代理頁面
    component: Proxy,
    path: '/affiliate'
  },
  {
    // 每日活動
    component: DailyAttend,
    path: '/match/DailyAttend',
    name: 'DailyAttend'
  },
  {
    // 忘記密碼-重設密碼
    component: ResetPassword,
    path: '/forgot_password/:username/:validate_code'
  },
  {
    // 收銀台
    component: CheckoutCounter,
    path: '/ubifrost',
    beforeEnter: (to, from, next) => {
      if (to.fullPath.includes('/ubifrost')) {
        // 如果包含，則進行某些處理或重定向
        next() // 或者你可以進行其他操作
      }
    }
  },
  {
    // 收銀台_BCPay
    component: CheckoutCounterBCPay,
    path: '/bigcat',
    beforeEnter: (to, from, next) => {
      if (to.fullPath.includes('/bigcat')) {
        // 如果包含，則進行某些處理或重定向
        next()
      }
    }
  },
  {
    component: Main,
    path: '/',
    children: [
      {
        path: '',
        component: () => import('@/views/index'),
        name: 'Index',
        meta: { needCookie: true, needRedirect: true }
      },
      {
        path: 'index',
        component: () => import('@/views/index'),
        name: 'HomeIndex',
        meta: { needCookie: true, needRedirect: true }
      },
      {
        path: 'event',
        component: () => import('@/views/event/index'),
        name: 'eventList',
        meta: { menuName: 'Event', needCookie: true }
      },
      {
        path: 'deposit',
        component: () => import('@/views/payment/deposit'),
        name: 'Deposit',
        meta: { needLogin: true, menuName: 'Deposit', needCookie: true }
      },
      {
        path: 'withdrawal',
        component: () => import('@/views/payment/withdrawal'),
        meta: { needLogin: true, menuName: 'Withdrawal', needCookie: true }
      },
      {
        path: 'points',
        component: () => import('@/views/shop/index'),
        children: [
          {
            path: 'overview',
            component: () => import('@/views/shop/overview'),
            name: 'Overview',
            meta: { needLogin: true, menuName: 'Overview' }
          },
          {
            path: 'coupon',
            beforeEnter: (to, from, next) => {
              if (store.getters.memberInfo.member_type === 3) {
                next('/points/membership-benefits')
                showNotice(i18n.t('Bao.lite_limit'))
              } else {
                next()
              }
            },
            component: () => import('@/views/shop/coupon'),
            name: 'Coupon',
            meta: { needLogin: true, menuName: 'Coupon', isLitePlayer: true }
          },
          {
            path: 'free-spin',
            component: () => import('@/views/shop/freeSpin'),
            name: 'freeSpin',
            meta: { needLogin: true, menuName: 'freeSpin' }
          },
          {
            path: 'roulette-bonus',
            component: () => import('@/views/shop/rouletteBonus'),
            name: 'rouletteBonus',
            meta: { needLogin: true, menuName: 'rouletteBonus' }
          },
          {
            path: 'membership-benefits',
            component: () => import('@/views/shop/membership'),
            name: 'membershipBenefits',
            meta: { needLogin: true, menuName: 'membershipBenefits' }
          },
          {
            path: 'vip-rewards',
            beforeEnter: (to, from, next) => {
              if (store.getters.memberInfo.member_type === 3) {
                next('/points/membership-benefits')
                showNotice(i18n.t('Bao.lite_limit'))
              } else {
                next()
              }
            },
            component: () => import('@/views/shop/rewards'),
            name: 'vipRewards',
            meta: { needLogin: true, menuName: 'vipRewards', isLitePlayer: true }
          }
        ]
      },
      {
        path: 'user',
        component: () => import('@/views/user/head'),
        children: [
          {
            path: '',
            component: () => import('@/views/user/personal'),
            name: 'Personal',
            meta: { needLogin: true, menuName: 'Personal', needCookie: true }
          },
          {
            path: 'edit',
            component: () => import('@/views/user/edit'),
            name: 'EditName'
          },
          {
            path: 'KYC',
            component: () => import('@/views/user/KYC'),
            name: 'KYC'
          },
          {
            path: 'letter',
            component: () => import('@/views/user/letter'),
            meta: { needLogin: true, menuName: 'Letter', needCookie: true },
            name: 'Message'
          },
          {
            path: 'wallet-history',
            component: () => import('@/views/transaction/mobile'),
            meta: { needLogin: true, menuName: 'WalletHistory', needCookie: true },
            name: 'Transaction'
          },
          {
            path: 'transaction',
            component: () => import('@/views/transaction/main'),
            meta: { needLogin: true, menuName: 'MainTransaction', needCookie: true },
            name: 'Transaction'
          },
          {
            path: 'bonus',
            component: () => import('@/views/transaction/bonus'),
            meta: { needLogin: true, menuName: 'BonusTransaction', needCookie: true },
            name: 'UserBonus'
          },
          {
            path: 'commission',
            component: () => import('@/views/transaction/commission'),
            meta: { needLogin: true, menuName: 'CommissionTransaction', needCookie: true },
            name: 'UserCommission'
          },
          {
            path: 'deposit-record',
            component: () => import('@/views/payment/depositRecord'),
            meta: { needLogin: true, menuName: 'DepositRecord', needCookie: true },
            name: 'DepositRecord'
          },
          {
            path: 'withdrawal-record',
            component: () => import('@/views/payment/withdrawalRecord'),
            meta: { needLogin: true, menuName: 'WithdrawalRecord', needCookie: true },
            name: 'WithdrawalRecord'
          },
          {
            path: 'bank',
            component: () => import('@/views/bank/index'),
            meta: { needLogin: true, menuName: 'Bank', needCookie: true },
            name: 'Bank'
          },
          {
            path: 'bank/create',
            component: () => import('@/views/bank/create'),
            meta: { needLogin: true, menuName: 'BankCard', needCookie: true },
            name: 'BankCard'
          },
          {
            path: 'bet',
            component: () => import('@/views/user/bet'),
            meta: { needLogin: true, menuName: 'UserBet', needCookie: true },
            name: 'UserBet'
          },
          {
            path: 'news',
            component: () => import('@/views/user/news'),
            meta: { menuName: 'News', needCookie: true },
            name: 'News'
          },
          {
            path: 'friend',
            component: () => import('@/views/user/friend'),
            name: 'UserFriend',
            meta: { needLogin: true, menuName: 'UserFriend', needCookie: true }
          },
          {
            path: 'event/me',
            component: () => import('@/views/event/me'),
            meta: { needLogin: true, menuName: 'EventMe', needCookie: true },
            name: 'Bonus'
          },
          {
            path: 'event/me/:task_id',
            component: () => import('@/views/event/me'),
            meta: { needLogin: true, menuName: 'EventMe', needCookie: true },
            name: 'Bonus'
          }
        ]
      },
      {
        path: 'vip',
        component: () => import('@/views/vip/index'),
        name: 'VipIndex',
        meta: { needCookie: true }
      }
    ]
  },
  {
    component: Account,
    path: '/',
    children: [
      {
        path: '/user/register',
        component: () => import('@/views/user/register'),
        name: 'Register'
      }
    ]
  },
  {
    component: Main,
    path: '/page',
    children: [
      {
        path: 'cooperation',
        component: () => import('@/views/page/cooperation'),
        name: 'PageCooperation',
        meta: { needCookie: true }
      },
      {
        path: 'support',
        component: () => import('@/views/page/support'),
        name: 'Support',
        meta: { needCookie: true }
      },
      {
        path: 'privacy',
        component: () => import('@/views/page/privacy'),
        name: 'PagePrivacy',
        meta: { needCookie: true }
      },
      {
        path: 'about',
        component: () => import('@/views/page/about'),
        name: 'PageAbout',
        meta: { needCookie: true }
      },
      {
        path: 'rule',
        component: () => import('@/views/page/rule'),
        name: 'PageRule',
        meta: { needCookie: true }
      },
      {
        path: 'agent',
        component: () => import('@/views/page/agent'),
        name: 'PageAgent',
        meta: { needCookie: true }
      },
      {
        path: 'vip',
        component: () => import('@/views/page/vip')
      },
      {
        path: 'terms',
        component: () => import('@/views/page/terms'),
        name: 'PageTerms',
        meta: { needCookie: true }
      },
      {
        path: 'cookie-policy',
        component: () => import('@/views/page/cookiePolicy'),
        name: 'PageCookiePolicy',
        meta: { needCookie: true }
      },
      {
        path: 'sup-how-to-register',
        component: () => import('@/views/page/sup/sup-how-to-register'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-how-to-login',
        component: () => import('@/views/page/sup/sup-how-to-login'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-payment-method',
        component: () => import('@/views/page/sup/sup-payment-method'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-account-binding',
        component: () => import('@/views/page/sup/sup-account-binding'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-wallet',
        component: () => import('@/views/page/sup/sup-wallet'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-event-bonus',
        component: () => import('@/views/page/sup/sup-event-bonus'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-about-shop',
        component: () => import('@/views/page/sup/sup-about-shop'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-coupon',
        component: () => import('@/views/page/sup/sup-coupon'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-vip-class-upgrading',
        component: () => import('@/views/page/sup/sup-vip-class-upgrading'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-verify-your-account',
        component: () => import('@/views/page/sup/sup-verify-your-account'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-faq',
        component: () => import('@/views/page/sup/sup-faq'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-responsible-gaming',
        component: () => import('@/views/page/sup/sup-responsible-gaming'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-recommended-games',
        component: () => import('@/views/page/sup/sup-recommended-games'),
        meta: { needCookie: true }
      }
    ]
  },
  {
    component: Main,
    path: '/vip',
    children: [
      {
        path: '',
        component: () => import('@/views/layout/Menu'),
        children: [
          {
            path: '',
            component: () => import('@/views/vip/index'),
            name: 'Vip'
          }
        ]
      }
    ]
  },
  {
    name: 'Campaign',
    component: Campaign,
    props: true,
    path: '/campaign/:prize_rate/:time_period'
  },
  {
    component: Main,
    path: '/transaction',
    children: [
      {
        path: '',
        component: () => import('@/views/layout/Menu'),
        children: [
          {
            path: '',
            component: () => import('@/views/transaction/main'),
            meta: { needLogin: true, menuName: 'MainTransaction' }
          },
          {
            path: 'bonus',
            component: () => import('@/views/transaction/bonus'),
            meta: { needLogin: true, menuName: 'BonusTransaction' }
          },
          {
            path: 'commission',
            component: () => import('@/views/transaction/commission'),
            meta: { needLogin: true, menuName: 'CommissionTransaction' }
          }
        ]
      }
    ]
  },
  {
    component: Blank,
    path: '/',
    children: [
      {
        path: 'share',
        component: () => import('@/views/share'),
        name: 'Share'
      }
    ]

  },
  {
    component: Webview,
    path: '/web',
    children: [
      {
        path: 'deposit-record',
        component: () => import('@/views/payment/depositRecord'),
        meta: { needLogin: true }
      },
      {
        path: 'transaction',
        component: () => import('@/views/transaction/main'),
        meta: { needLogin: true }
      },
      {
        path: 'transaction/bonus',
        component: () => import('@/views/transaction/bonus'),
        meta: { needLogin: true }
      },
      {
        path: 'transaction/commission',
        component: () => import('@/views/transaction/commission'),
        meta: { needLogin: true }
      },
      {
        path: 'user/bet',
        component: () => import('@/views/user/bet'),
        meta: { needLogin: true }
      },
      {
        path: 'event/me',
        component: () => import('@/views/event/me'),
        meta: { needLogin: true }
      },
      {
        path: 'event/me/:task_id',
        component: () => import('@/views/event/me'),
        meta: { needLogin: true, menuName: 'EventMe' }
      }
    ]
  },
  {
    path: '/critical',
    component: () => import('@/views/errorPage/critical'),
    name: 'Critical'
  }
]

export default new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (to.name === 'Index') return
    else return { y: 0 }
  },
  routes: routerMap
})
